module.exports = __webpack_public_path__ + "media/images/products/shop/8-f3f966378ed3a295416247a3113af080.jpg";